import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <article
      className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
      data-product-shop=""
    >
      <Link to={`/category/${video.categorySlug}`} className="block">
        <div className="relative aspect-video overflow-hidden">
          <img
            src={video.thumbnail}
            alt={video.title}
            title={`${video.title} - 向日葵视频免费在线观看`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute bottom-2 right-2 bg-background-950/80 text-background-50 text-xs px-2 py-0.5 rounded-md">
            {video.duration}
          </div>
          <div className="absolute top-2 left-2">
            <span className="bg-primary-500/90 text-background-50 text-xs px-2 py-0.5 rounded-md">
              {video.rating}
            </span>
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
            <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-xl ml-0.5" />
            </div>
          </div>
        </div>
      </Link>
      <div className="p-3">
        <Link to={`/category/${video.categorySlug}`}>
          <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200 mb-1.5">
            {video.title}
          </h3>
        </Link>
        <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{video.description}</p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400">
            <i className="ri-eye-line mr-1" />
            {video.views}
          </span>
          <Link
            to={`/category/${video.categorySlug}`}
            className="text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
          >
            {video.category}
          </Link>
        </div>
      </div>
    </article>
  );
}